import axios from "axios";
import React, { Component } from "react";
import Autosuggest from "react-autosuggest";
import {
  addCharter,
  getAirportsDetails,
  getAirlineDetails,
} from "../../Service/CharterService";

export default class AirportDestination extends Component {
  constructor() {
    super();

    //Define state for value and suggestion collection
    this.state = {
      value: "",
      suggestions: [],
    };
  }

  // Filter logic
  getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const data = await getAirlineDetails(value);
    const airlineDetails = [];

    data.map((detail) =>
      airlineDetails.push({
        id: detail.id,
        label: `${detail.carrierCode} ${detail.carrierName}`,
      })
    );
    return airlineDetails;
  };

  onSuggestionSelected = (id, suggestionValue) => {
    this.setState({
      value: suggestionValue.label,
    });
    this.props.setFieldValue(id, suggestionValue.id);
  };

  // Trigger suggestions
  getSuggestionValue = (suggestion) => suggestion;

  // Render Each Option
  renderSuggestion = (suggestion) => <div>{suggestion.label}</div>;

  // OnChange event handler
  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
    this.props.setFieldValue(
      `flightLegs.onward[${this.props.index}].flightCarrierId`,
      ""
    );
  };

  // Suggestion rerender when user types
  onSuggestionsFetchRequested = ({ value }) => {
    this.getSuggestions(value).then((data) => {
      if (data.Error) {
        this.setState({
          suggestions: [],
        });
      } else {
        this.setState({
          suggestions: data,
        });
      }
    });
  };

  // Triggered on clear
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  render() {
    const { value, suggestions } = this.state;

    // Option props
    const inputProps = {
      placeholder: "Carrier",
      value,
      onChange: this.onChange,
      className: "form-control",
      id: `flightLegs.onward[${this.props.index}].flightCarrierId`,
      name: `flightLegs.onward[${this.props.index}].flightCarrierId`,
    };

    // Adding AutoSuggest component
    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        onSuggestionSelected={(event, { suggestionValue }) => {
          this.onSuggestionSelected(
            `flightLegs.onward[${this.props.index}].flightCarrierId`,
            suggestionValue
          );
        }}
      />
    );
  }
}
